import React, { FC, HTMLAttributes } from 'react';
import { styled } from 'linaria/react';
interface SpacerProps extends HTMLAttributes<HTMLDivElement> {
  /**
   * Высота и минимальная ширина компонента при разрешении от 1024px
   */
  space?: number;
  /**
   * Высота и минимальная ширина компонента при разрешении менее 1024px
   */
  spacemob?: number;
  /**
   * Высота и минимальная ширина компонента при разрешении менее 768px
   */
  spacetablet?: number;
  /**
   * включает/ выключает spacemob поведение
   */
  samespace?: boolean;
}
const _exp2 = /*#__PURE__*/() => ({
  spacemob = 20
}) => spacemob;
const _exp4 = /*#__PURE__*/() => ({
  spacetablet = 20
}) => spacetablet;
const _exp6 = /*#__PURE__*/() => ({
  space = 20
}) => space;
const Inner = /*#__PURE__*/styled('div')({
  name: "Inner",
  class: "if9bgtn",
  propsAsIs: false,
  vars: {
    "if9bgtn-0": [_exp2(), "px"],
    "if9bgtn-1": [_exp4(), "px"],
    "if9bgtn-2": [_exp6(), "px"]
  }
});
const Spacer: FC<SpacerProps> = ({
  space = 20,
  spacemob,
  spacetablet,
  // Добавляем пропс spacetablet
  samespace = false,
  ...rest
}) => <Inner data-testid="spacer" space={space} spacemob={spacemob} spacetablet={spacetablet} // Передаем пропс spacetablet
samespace={samespace} {...rest} />;
export default Spacer;

require("./Spacer.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./Spacer.tsx");